// extracted by mini-css-extract-plugin
export default {"wrapper":"w3kwIbu","vertical":"M36yU4L","dotted":"qVvvjVE","dashed":"aHxckcJ"};